import * as React from 'react';

import { cn } from 'lib/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          'flex min-h-[80px] w-full border border-[var(--line-strong)] bg-[var(--input-bg)] px-3.5 py-2.5 text-sm text-[var(--text)] transition-[border-color,box-shadow] placeholder:text-[var(--text-muted)] placeholder:opacity-80 focus-visible:border-[var(--accent)] focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-[var(--ring-color)] disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
